export const OPENAI_QUOTA_ERROR_CODE = 'openai_quota_exhausted';
export const OPENAI_BILLING_URL = 'https://platform.openai.com/settings/organization/billing/overview';
